module.exports = __webpack_public_path__ + "img/233.773e998b.png";